import { createContext, useContext } from 'react';

export const RootLayoutContext = createContext({ showFooter: false });

RootLayoutContext.displayName = 'RootLayoutContext';

export const useRootLayoutContext = () => useContext(RootLayoutContext);
